class DesktopNav {
  constructor() {
    this.body = document.querySelector("body")
    this.desktopMenu = document.getElementById("desktop-menu")
    this.searchModal = document.getElementById("search-modal")
    this.modalOverlay = document.querySelector("[js-modal-overlay]")
    this.searchForm = document.getElementById("CacheableForm_DesktopSearch")
    this.searchButton = document.getElementById("open-search")
    this.searchSkipLink = document.getElementById("skip-to-search")
    this.navButtons = document.querySelectorAll(".site-header__nav-button")
    this.megaNavs = document.querySelectorAll(".site-header__mega-nav")
    this.megaNavChildLinks = document.querySelectorAll(".site-header__mega-nav__child-link a")
    this.subNavButtons = document.querySelectorAll(".site-header__sub-nav-button")
    this.subNavs = document.querySelectorAll(".site-header__mega-nav__grandchildren")

    if (this.searchSkipLink) {
      this.searchSkipLink.addEventListener("click", ev => {
        ev.preventDefault()
        this.toggleSearchModal()
      })
    }

    if (this.searchButton) {
      this.searchButton.addEventListener("click", ev => {
        ev.preventDefault()
        this.toggleSearchModal()
      })
    }

    this.modalOverlay.addEventListener("click", () => {
      this.returnToNav()
    })

    document.addEventListener("keydown", e => {
      if (e.code == "Escape") {
        this.returnToNav()
      }
    })

    for (let i = 0; i < this.navButtons.length; i++) {
      let button = this.navButtons[i]

      button.addEventListener("click", ev => {
        ev.preventDefault()
        this.toggleNav(ev.currentTarget, true)
      })
    }

    for (let i = 0; i < this.subNavButtons.length; i++) {
      let button = this.subNavButtons[i]

      button.addEventListener("click", ev => {
        if (!ev.currentTarget.classList.contains("active")) {
          this.toggleNav(ev.currentTarget, false)
        }
      })
    }

    for (let i = 0; i < this.megaNavChildLinks.length; i++) {
      let link = this.megaNavChildLinks[i]

      link.addEventListener("keydown", ev => {
        this.exitSubNav(ev, link)
      })
    }
  }

  toggleSearchModal(open) {
    this.closeOpenMegaNavs(this.searchModal.id)

    if (typeof open !== "boolean") {
      open = !this.searchModal.classList.contains("open")
    }

    this.searchModal.classList.toggle("open", open)
    this.searchModal.setAttribute("aria-hidden", !open)
    this.searchButton.setAttribute("aria-expanded", open)
    this.modalOverlay.classList.toggle("show", open)

    if (open) {
      this.searchForm.querySelector("input").focus()
    }
  }

  closeNavigation(event) {
    if (!this.desktopMenu) {
      return
    }

    const menuClick = this.desktopMenu.contains(event?.target)
    if (!menuClick) {
      this.closeOpenMegaNavs()
    }
  }

  toggleNav(button, isMegaNav) {
    const id = button.getAttribute("data-target")
    const nav = document.getElementById(id)

    if (!nav) {
      const href = button.getAttribute("href")
      location.href = href
      return
    }

    this.closeOpenSubNavs(id)

    if (isMegaNav) {
      this.closeOpenMegaNavs(id)
      this.modalOverlay.classList.toggle("show", isMegaNav)
      document.querySelectorAll(".nav-active").forEach(el => el.classList.remove("nav-active"))
    } else {
      nav.parentElement.classList.add("nav-active")
    }

    if (nav.classList.contains("active")) {
      this.returnToNav()
    } else {
      button.classList.add("active")
      button.setAttribute("aria-expanded", true)
      nav.classList.add("active")
      nav.setAttribute("aria-hidden", false)

      if (!isMegaNav) {
        nav.firstElementChild.querySelector("a").focus()
      }
    }

    const activeMegaNav = document.querySelector(".site-header__mega-nav.active")

    if (activeMegaNav) {
      let contentEl = this.body.querySelector("#Content")

      const menuHeight = activeMegaNav.offsetHeight
      const windowHeight = window.innerHeight
      const footerHeight = document.querySelector(".site-footer").offsetHeight

      const newHeight = menuHeight + footerHeight > windowHeight ? menuHeight : windowHeight - footerHeight
      contentEl.style.maxHeight = newHeight + "px"
      contentEl.style.overflow = "hidden"
    }
  }

  exitSubNav(ev, link) {
    var charCode = ev.which || ev.keyCode
    if (charCode === 9 && ev.shiftKey) {
      ev.preventDefault()
      const button = document.getElementById(link.id.replace("parent", "button"))
      button.focus()
    }
  }

  closeOpenMegaNavs(id) {
    for (let i = 0; i < this.navButtons.length; i++) {
      let button = this.navButtons[i]
      if (button.getAttribute("data-target") != id) {
        button.classList.remove("active")
        button.setAttribute("aria-expanded", false)
      }
    }

    for (let i = 0; i < this.megaNavs.length; i++) {
      let megaNav = this.megaNavs[i]
      if (megaNav.id != id) {
        megaNav.classList.remove("active")
        megaNav.setAttribute("aria-hidden", true)
      }
    }
  }

  closeOpenSubNavs(id) {
    for (let i = 0; i < this.subNavButtons.length; i++) {
      let button = this.subNavButtons[i]
      if (button.getAttribute("data-target") != id) {
        button.classList.remove("active")
      }
    }

    for (let i = 0; i < this.subNavs.length; i++) {
      let subNav = this.subNavs[i]
      if (subNav.id != id) {
        subNav.classList.remove("active")
      }
    }
  }

  returnToNav() {
    this.toggleSearchModal(false)
    let contentEl = this.body.querySelector("#Content")
    contentEl.style.maxHeight = "unset"
    contentEl.style.overflow = "auto"
  }
}

export default DesktopNav
